import { Reveal } from "@/components/ui/motion";

// Logo assets sourced from mitrakaryalawoffice.com; names from mitrakarya.group
const BANKS = [
  { name: "BNI", logo: "bank-1" },
  { name: "Mandiri", logo: "bank-2" },
  { name: "BRI", logo: "bank-3" },
  { name: "Bank Mega", logo: "bank-4" },
  { name: "BCA", logo: "bank-5" },
  { name: "HSBC", logo: "bank-6" },
  { name: "Maybank", logo: "bank-7" },
  { name: "CIMB Niaga", logo: "bank-8" },
  { name: "OCBC NISP", logo: "bank-9" },
  { name: "Standard Chartered", logo: "bank-10" },
  { name: "DBS" },
  { name: "Permata" },
  { name: "UOB" },
  { name: "CTBC" },
  { name: "Danamon" },
  { name: "MNC" },
  { name: "Panin" },
];

const ROW_A = BANKS.filter((_, i) => i % 2 === 0);
const ROW_B = BANKS.filter((_, i) => i % 2 === 1);

const Chip = ({ b }) => (
  <li className="group mx-2.5 flex h-20 w-[200px] shrink-0 items-center justify-center rounded-2xl border border-line bg-white px-6 transition-[border-color,box-shadow] duration-500 hover:border-sky-brand hover:shadow-[0_18px_40px_-28px_rgba(2,132,199,.6)] sm:h-24 sm:w-[230px]" data-testid={`bank-${b.name.toLowerCase().replace(/\s+/g, "-")}`}>
    {b.logo ? (
      <span
        role="img"
        aria-label={`Logo ${b.name}`}
        className="block h-11 w-full bg-slateb transition-colors duration-500 group-hover:bg-accentb"
        style={{ WebkitMask: `url(/images/banks/${b.logo}.svg) center / contain no-repeat`, mask: `url(/images/banks/${b.logo}.svg) center / contain no-repeat` }}
      />
    ) : (
      <span className="font-display text-2xl font-bold tracking-tight text-slateb transition-colors duration-500 group-hover:text-accentb">{b.name}</span>
    )}
  </li>
);

const Row = ({ items, reverse }) => (
  <div className="flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
    <ul className={`marquee-track flex w-max ${reverse ? "[animation-direction:reverse]" : ""}`}>
      {[...items, ...items, ...items, ...items].map((b, i) => <Chip key={`${b.name}-${i}`} b={b} />)}
    </ul>
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-line bg-ice/50 py-16 sm:py-20" aria-labelledby="bank-heading" data-testid="bank-marquee">
    <div className="wrap mb-10 flex flex-col justify-between gap-4 sm:mb-12 lg:flex-row lg:items-end">
      <Reveal>
        <span className="eyebrow">Bank &amp; Lembaga Keuangan</span>
        <h2 id="bank-heading" className="mt-4 max-w-2xl font-display text-2xl font-bold leading-tight sm:text-3xl lg:text-4xl">
          Pengalaman pendampingan dengan <span className="serif-it font-normal text-accentb">berbagai institusi keuangan.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.08}>
        <p className="max-w-md text-[14.5px] leading-relaxed text-ink">Setiap kreditur memiliki kebijakan berbeda. Pengalaman ini membantu kami menjelaskan opsi yang lebih realistis untuk kondisi Anda.</p>
      </Reveal>
    </div>
    <div className="space-y-4">
      <Row items={ROW_A} />
      <Row items={ROW_B} reverse />
    </div>
    <p className="wrap mt-8 text-[12px] text-ink-soft">Nama dan logo merupakan milik masing-masing institusi dan ditampilkan sebagai referensi pengalaman, bukan bentuk afiliasi atau kerja sama resmi.</p>
  </section>
);
